import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import QueryClientProvider from './components/shared/QueryClientProvider';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { HelmetProvider } from 'react-helmet-async';
import getEnvConfig from './utils/environmentHelpers/getEnvConfig';
import getApiEnvironment from './utils/environmentHelpers/getAPIEnvironments';
import { maybeStartMocks } from './utils/siteSupport';
import { muiProLicense } from './scripts/miscConstants';
import { LicenseInfo } from '@mui/x-license';

LicenseInfo.setLicenseKey(muiProLicense);

const appInsights = new ApplicationInsights({
	config: {
		connectionString: getEnvConfig(
			getApiEnvironment(),
			'applicationInsightConnectionString'
		),
		enableAutoRouteTracking: true,
	},
});
appInsights.loadAppInsights();
appInsights.trackPageView();

maybeStartMocks(process.env.NODE_ENV).then(() => {
	const root = ReactDOM.createRoot(document.getElementById('root'));
	root.render(
		<QueryClientProvider>
			<React.StrictMode>
				<HelmetProvider>
					<App />
				</HelmetProvider>
			</React.StrictMode>
		</QueryClientProvider>
	);
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
